module.exports = __webpack_public_path__ + "static/media/banner2.08243e2a.png";